export default function classesToSelector(classes = '') {
  return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/wordpresssmsv/wp-content/themes/smsv/node_modules/swiper/shared/classes-to-selector.js
// module id = 11
// module chunks = 0